export default "__VITE_ASSET__4821e0bc__"